import * as React from 'react'
import { IDepRequestResult } from '../../../../services/TipService'
import * as _ from 'lodash'
import { tipService } from '../../../../services'
import { Button, Divider, Grid, Message } from 'semantic-ui-react'
import * as CopyToClipboard from 'react-copy-to-clipboard'
import { vietqr } from '../../../../utils/vietqr'
import { QrCodeImage } from '../../../components/QrCodeImage'

type TipRequestResultProps = {
  isSuccess: boolean,
  tipId: number,
  depId: number
}

type TipRequestResultState = {
  infoString: string,
  bankInfo?: TipBankInfo,
  depRequest?: IDepRequestResult,
}

export default class TipRequestResult extends React.Component<TipRequestResultProps, TipRequestResultState> {
  state: TipRequestResultState = {
    infoString: ''
  }

  async componentDidMount() {
    await this.getTipRequestResult()
  }

  getTipRequestResult = async () => {
    if (_.isNil(this.props.tipId) || _.isNil(this.props.depId)) {
      this.setState({
        infoString: ''
      })
      return
    }

    const tipRequestResult = await tipService.getTipRequestInfo(this.props.tipId)
    const depRequestResult = await tipService.getDepRequestInfo(this.props.depId)

    const info = `Yêu cầu mua ${tipRequestResult.amount.toLocaleString('vn')} value gửi đến tài khoản có `
      + `Steam ID ${tipRequestResult.steamId} thành công`

    this.setState({
      infoString: info,
      depRequest: depRequestResult,
      bankInfo: depRequestResult.bank
    })
  }

  render() {
    const {depRequest, infoString, bankInfo} = this.state
    const content = depRequest ? `TD${depRequest.id} mua steam` : ''
    const actualAmount = depRequest ? depRequest.actualAmount : 0
    const srcQrCode = bankInfo && depRequest
      ? vietqr.generateUrl(bankInfo.code, bankInfo.accountNumber, actualAmount, content, bankInfo.accountName)
      : ''

    if (!this.props.isSuccess || !depRequest || !bankInfo) {
      return (
        <Message
          error={true}
          header={'Yêu cầu mua hàng gặp lỗi'}
        >
          Chúng tôi rất tiếc đã có lỗi xảy ra khi yêu cầu mua hàng
          Quý khách vui lòng với admin để được hỗ trợ! Xin chân thành cảm ơn
        </Message>
      )
    }
    return (
      <div>
        <Message icon={'check'} success={true} header={infoString}/>
        <Message info={true}>

          <Message.Header>Để hoàn tất mua hàng, bạn vui lòng chuyển khoản với thông tin như sau:</Message.Header>
          <Grid columns={2} stackable={true}>
            <Grid.Row>
              {srcQrCode &&
                <Grid.Column>
                  <br/> Quét mã QR để thanh toán
                  <QrCodeImage src={srcQrCode}/>
                </Grid.Column>
              }
              <Grid.Column>
                {srcQrCode && <Divider>Hoặc</Divider>}
                <br/> Chuyển khoản qua
                <Message.List>
                  <Message.Item>Ngân hàng: <strong>{bankInfo.name}</strong></Message.Item>
                  <Message.Item>Số tài khoản: <strong>{bankInfo.accountNumber}</strong>
                    <CopyToClipboard
                      text={bankInfo.accountNumber}
                    >
                      <Button size="mini" color="green" style={{marginLeft: '8px'}}>Sao chép số tài khoản</Button>
                    </CopyToClipboard>
                  </Message.Item>
                  <Message.Item>Tên tài khoản: <strong>{bankInfo.accountName}</strong></Message.Item>
                  <Message.Item>Số tiền: <strong>
                    {depRequest.actualAmount.toLocaleString('vn')}đ
                    {depRequest.actualAmount !== depRequest.amount
                      ? ` (${depRequest.amount.toLocaleString('vn')} `
                      + `+ Phí: ${(depRequest.actualAmount - depRequest.amount).toLocaleString('vn')})`
                      : ''}
                  </strong>
                  </Message.Item>
                  <Message.Item>Nội dung: <strong>{content}</strong>
                    <CopyToClipboard
                      text={`TD${depRequest.id} mua steam`}
                    >
                      <Button size="mini" color="green" style={{marginLeft: '8px'}}>Sao chép nội dung</Button>
                    </CopyToClipboard>
                  </Message.Item>
                </Message.List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Message>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Tip/TipRequestResult.tsx